export const DRAW_PRIZE = 'PRIZE_PILE/DRAW_PRIZE';
export const END_DRAW_PRIZE = 'PRIZE_PILE/END_DRAW_PRIZE';

